import React, {useEffect, useState} from 'react';
import CloseIcon from '../../../assets/Icons/Interface/CloseIcon';
import {TacticI} from '../../../interfaces/general';
import Boolean from '../../../components/Form/Boolean';
import Editor from '../../../components/Form/Editor';
import {buttonStyle} from '../../../styles/classes';
import {useLazyQuery, useMutation} from '@apollo/client';
import {query} from '../../../services/queries/queries';
import {
	subtacticCreateOne,
	subtacticUpdateOne,
} from '../../../services/queries/mutations';
import {slugify} from '../../../utils/misc';
import TacticSelector from '../../../components/Form/TacticSelector';

interface TacticFormI {
	tId?: string
	setTId?: (t:string) => void
	setForm?: (f:boolean) => void
	setLoading?: (f:boolean) => void
}

export default function SubtacticForm({tId, setForm, setLoading, setTId}:TacticFormI) {

	const [t, setT] = useState<TacticI>();
	const [body, setBody] = useState<string>(t?.description || "");

	const [queryTactics, { data }] = useLazyQuery(query("subtacticFindMany"));
	const [tacticUpdate, { data:updateData, loading, error }] = useMutation(subtacticUpdateOne);
	const [tacticCreate, { data:createData, loading:createLoading, error:createError }] = useMutation(subtacticCreateOne);


	useEffect(()=>{
		if(tId){
			queryTactics({
				variables: {filter: {_id: tId}},
				fetchPolicy: 'no-cache',
				onCompleted: (data:any):void => buildEntry(data.subtacticFindMany[0])
			});
		}
	},[tId]);

	const buildEntry = (data:TacticI) => {
		setT({
			active: data?.active,
			title: data?.title,
			tactic: data?.tactic
		});

		setBody(data?.description || "");
	}

	const onSubmit = (e:any) => {
		e.preventDefault();
		const record = {
			title: t?.title,
				slug: slugify(t?.title || ""),
				description: body,
				active: t?.active || false,
				tactic: t?.tactic
		}
		if(tId){
			tacticUpdate({
				variables : {
					record,
					filter: { _id: tId }
				},
				onCompleted: (data:any):void => finishSave()
			});
		}
		else {
			tacticCreate({
				variables : {
					record
				},
				onCompleted: (data:any):void => finishSave()
			});
		}
	}

	const finishSave = () => {
		if(setLoading){
			setLoading(true);
		}
		if(setForm){
			setForm(false);
		}
		if(setTId){
			setTId("");
		}
	}

	return (
		<div className="max-w-500px width-500px">
			<div className="flex align-start">
				<h4 className="mb-2 f-urbanist grows">
					{tId ? "Edit" : "Create"} Subtactic
				</h4>
				<a onClick={()=>setForm ? setForm(false) : null}>
					<CloseIcon />
				</a>
			</div>

			<form
				onSubmit={onSubmit}
				onKeyPress={(e) => {
					if (e.key === "Enter" && e.target.type === "text") {
						e.preventDefault();
					}
				}}
			>
				<p className="mb">
					<label>Title</label>
					<input
						type="text"
						name="title"
						placeholder="Title"
						value={t?.title || ""}
						onChange={(e)=>setT({...t, title:e.target.value})}
					/>
				</p>

				<p className="mb">
					<label>Tactic</label>
					<TacticSelector selected={t?.tactic ? [t?.tactic] : [""]} setSelected={(s)=>setT({...t, tactic: s[0]})} />
				</p>


				<div className="mb" style={{color: "black"}}>
					<label>
						Description
					</label>
					<Editor data={body} setDescription={(d:string)=>setBody(d)} />
				</div>

				<div className="mb">
					<label>
						{t?.active ? "Published" : "Draft"}
					</label>
					<Boolean value={t?.active ? t.active : false} setValue={()=> setT({...t, active: !t?.active})} />
				</div>

				<p className="pb-2">
					<button className={buttonStyle}>
						Save
					</button>
				</p>

			</form>
		</div>
	)
}
